import {
	LocalPhone,
	Print,
	CalendarToday,
	Person,
	Cake,
	Favorite,
	Healing,
	Assignment,
	Schedule,
	Info,
} from "@mui/icons-material";
import {
	Box,
	Button,
	Chip,
	Divider,
	IconButton,
	Paper,
	Tooltip,
	Typography,
	Zoom,
} from "@mui/material";
import { useState } from "react";

const PhotoPrescriptionPreviewUpdate8Oct25 = ({ prescription }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const handlePrint = () => {
		const newWindow = window.open("", "", "width=1200,height=800");
		newWindow.document.write(`
      <html>
        <head>
          <title>স্বাস্থ্য উপদেশ</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              padding: 0;
              margin: 0;
              color: #333;
            }
            .container {
              max-width: 1200px;
              margin: 0 auto;
              background: white;
            }
            .top-spacer {
              height: 1.5in;
            }
            .header-line {
              display: flex;
              justify-content: space-between;
              padding: 10px 20px;
              border-bottom: 1px solid #ddd;
            }
            .header-line-1 {
              display: flex;
              gap: 30px;
              font-size: 14px;
            }
            .header-line-2 {
              display: flex;
              gap: 20px;
              font-size: 14px;
            }
            .doctor-name, .date {
              font-weight: bold;
            }
            .main-content {
              display: flex;
            }
            .left-panel {
              width: 20%;
              background: #f9fafb;
              padding: 20px;
              border-right: 1px solid #e5e7eb;
            }
            .right-panel {
              width: 80%;
              padding: 20px;
            }
            .section {
              margin-bottom: 20px;
            }
            .section-title {
              color: #1e40af;
              font-weight: bold;
              margin-bottom: 10px;
              font-size: 16px;
            }
            .left-section-title {
              color: #1e40af;
              font-weight: bold;
              margin-bottom: 8px;
              font-size: 14px;
            }
            ul { 
              list-style-type: disc; 
              margin-left: 20px; 
              padding-left: 15px;
            }
            li {
              padding: 3px 0;
              font-size: 14px;
            }
            .vitals {
              display: flex;
              flex-wrap: wrap;
              gap: 5px;
            }
            .vital-chip {
              background: #f0f9ff;
              border: 1px solid #3b82f6;
              padding: 2px 8px;
              border-radius: 4px;
              font-size: 12px;
            }
            .medicine-item, .test-item {
              margin-bottom: 8px;
              font-size: 14px;
            }
            @media print {
              body { margin: 0; }
              .container { max-width: none; }
            }
          </style>
        </head>
        <body>
          <div class="container">
            <!-- Top Spacer -->
            <div class="top-spacer"></div>
            
            <!-- Header Lines -->
            <div class="header-line">
              <div class="header-line-1">
                <div class="doctor-name">${prescription?.doctor_name || "N/A"}</div>
                <div class="date">${new Date(prescription?.creation_date || new Date()).toLocaleDateString()}</div>
              </div>
            </div>
            <div class="header-line">
              <div class="header-line-2">
                <div>${prescription?.patient_name || prescription?.name || "N/A"}</div>
                <div>${prescription?.patient_age || prescription?.age || "N/A"}</div>
                <div>${prescription?.patient_gender || "N/A"}</div>
              </div>
            </div>

            <!-- Main Content -->
            <div class="main-content">
              <!-- Left Panel -->
              <div class="left-panel">
                ${
                  prescription?.cc_list && Object.keys(JSON.parse(prescription.cc_list || "{}")).length > 0
                    ? `
                    <div class="section">
                      <div class="left-section-title">Chief Complaints</div>
                      <ul>
                        ${Object.values(JSON.parse(prescription.cc_list || "{}"))
                          .map((cc) => `<li>${cc}</li>`)
                          .join("")}
                      </ul>
                    </div>
                    `
                    : ""
                }
                
                ${
                  JSON.parse(prescription?.cc_list || "{}").on_exam || JSON.parse(prescription?.advices_list || "{}").on_exam
                    ? `
                    <div class="section">
                      <div class="left-section-title">On Exam</div>
                      <div style="font-size: 14px;">
                        ${JSON.parse(prescription?.cc_list || "{}").on_exam || JSON.parse(prescription?.advices_list || "{}").on_exam}
                      </div>
                    </div>
                    `
                    : ""
                }
                
                ${
                  JSON.parse(prescription?.advices_list || "{}").diagnosis
                    ? `
                    <div class="section">
                      <div class="left-section-title">Diagnostic Comments</div>
                      <div style="font-size: 14px;">
                        ${JSON.parse(prescription?.advices_list || "{}").diagnosis}
                      </div>
                    </div>
                    `
                    : ""
                }
              </div>

              <!-- Right Panel -->
              <div class="right-panel">
                ${
                  (prescription?.medicine && Array.isArray(prescription.medicine) && prescription.medicine.length > 0) ||
                  (prescription?.medicine_list && Object.keys(JSON.parse(prescription.medicine_list || "{}")).length > 0)
                    ? `
                    <div class="section">
                      <div class="section-title">Medicines</div>
                      <ul>
                        ${
                          prescription?.medicine && Array.isArray(prescription.medicine) && prescription.medicine.length > 0
                            ? prescription.medicine.map((med) => {
                                const medicineStr = (med.name || "") + " " + (med.strength || "") + " (" + (med.type || "") + ") - " + (med.dosage || "") + " " + (med.timing || "") + " for " + (med.continueTill || "");
                                const indicationStr = med.indication ? " - Indication: " + med.indication : "";
                                return "<li class=\"medicine-item\">" + medicineStr + indicationStr + "</li>";
                              }).join("")
                            : Object.values(JSON.parse(prescription.medicine_list || "{}"))
                                .map((medicine) => "<li class=\"medicine-item\">" + medicine + "</li>")
                                .join("")
                        }
                      </ul>
                    </div>
                    `
                    : ""
                }
                
                ${
                  prescription?.radiology_tests && prescription.radiology_tests.length > 0
                    ? `
                    <div class="section">
                      <div class="section-title">Radiology Tests</div>
                      <ul>
                        ${prescription.radiology_tests.map((test) => `<li class="test-item">${test[3]} - ${test[6]}</li>`).join("")}
                      </ul>
                    </div>
                    `
                    : ""
                }
                
                ${
                  prescription?.pathology_tests && prescription.pathology_tests.length > 0
                    ? `
                    <div class="section">
                      <div class="section-title">Pathology Tests</div>
                      <ul>
                        ${prescription.pathology_tests.map((test) => `<li class="test-item">${test[3]} - ${test[5]}</li>`).join("")}
                      </ul>
                    </div>
                    `
                    : ""
                }
                
                ${
                  prescription?.advices
                    ? `
                    <div class="section">
                      <div class="section-title">Advice</div>
                      <div class="medicine-item">${prescription.advices}</div>
                    </div>
                    `
                    : ""
                }
              </div>
            </div>
          </div>
        </body>
      </html>
    `);

		newWindow.document.close();
		newWindow.focus();
		setTimeout(() => {
			newWindow.print();
			newWindow.close();
		}, 500);
	};

	// Function to safely parse JSON with a fallback
	const safeParseJSON = (jsonString, fallback) => {
		try {
			return jsonString ? JSON.parse(jsonString) : fallback;
		} catch (error) {
			console.error("Error parsing JSON:", error);
			return fallback;
		}
	};

	const vitals = safeParseJSON(prescription?.vitals, {});
	const ccList = safeParseJSON(prescription?.cc_list, {});
	const medicineList = safeParseJSON(prescription?.medicine_list, {});
	const advicesList = safeParseJSON(prescription?.advices_list, {});
	const medicineUsageList = safeParseJSON(
		prescription?.medicine_usage_list,
		[]
	);
	
	// Parse additional fields from advices_list
	const diagnosis = advicesList.diagnosis || "";
	const onExam = advicesList.on_exam || "";
	// Get advices directly from prescription
	const advices = prescription?.advices || "";
	
	// Parse pathology and radiology tests from prescription
	const pathologyTests = prescription?.pathology_tests || [];
	const radiologyTests = prescription?.radiology_tests || [];

	return (
		<Paper className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg border border-blue-100 overflow-hidden">
			{/* Top Panel - 4 inches height */}
			<Box className="h-16 bg-gradient-to-r from-blue-600 to-blue-800 p-4 text-white flex items-center justify-between">
				<Box className="flex items-center space-x-6">
					<Typography variant="h5" className="font-bold">
						{prescription?.organization_name || "স্বাস্থ্য উপদেশ"}
					</Typography>
					<Box className="flex items-center">
						<CalendarToday fontSize="small" className="mr-1" />
						<Typography variant="body2">
							{new Date(prescription?.creation_date || new Date()).toLocaleDateString()}
						</Typography>
					</Box>
				</Box>
				<Box className="flex items-center space-x-4">
					<Box className="flex items-center">
						<Person className="text-white mr-2" />
						<Typography variant="body2">
							{prescription?.doctor_name || "N/A"}
						</Typography>
					</Box>
					<Box className="flex items-center">
						<Person className="text-white mr-2" />
						<Typography variant="body2">
							{prescription?.patient_name || prescription?.name || "N/A"}
						</Typography>
					</Box>
					<Box className="flex items-center">
						<Cake className="text-white mr-2" />
						<Typography variant="body2">
							{prescription?.patient_age || prescription?.age || "N/A"}, {prescription?.patient_gender || "N/A"}
						</Typography>
					</Box>
					<Tooltip title="Print Prescription">
						<IconButton
							onClick={handlePrint}
							size="small"
							className="bg-white text-blue-800"
						>
							<Print />
						</IconButton>
					</Tooltip>
				</Box>
			</Box>

			{/* Main Content - Two Panel Layout */}
			<Box className="flex">
				{/* Left Panel - 1/5th width */}
				<Box className="w-1/5 bg-gray-50 p-4 border-r border-gray-200">
					{/* Chief Complaints */}
					{Object.keys(ccList).length > 0 && (
						<Box className="mb-4">
							<Typography variant="subtitle2" className="font-semibold text-blue-800 mb-2">
								Chief Complaints
							</Typography>
							<ul className="list-disc ml-4 text-sm">
								{Object.values(ccList).map((cc, index) => (
									<li key={index} className="py-1 text-gray-800">
										{cc}
									</li>
								))}
							</ul>
						</Box>
					)}

					{/* Vitals */}
					{Object.keys(vitals).length > 0 && (
						<Box className="mb-4">
							<Typography variant="subtitle2" className="font-semibold text-blue-800 mb-2">
								Vitals
							</Typography>
							<Box className="space-y-1">
								{vitals.BP && (
									<Chip label={`BP: ${vitals.BP}`} size="small" className="bg-red-50 text-red-800" />
								)}
								{vitals.DM && (
									<Chip label={`DM: ${vitals.DM}`} size="small" className="bg-orange-50 text-orange-800" />
								)}
								{vitals.HTN && (
									<Chip label={`HTN: ${vitals.HTN}`} size="small" className="bg-purple-50 text-purple-800" />
								)}
								{vitals.pulse && (
									<Chip label={`Pulse: ${vitals.pulse}`} size="small" className="bg-blue-50 text-blue-800" />
								)}
								{vitals.weight && (
									<Chip label={`Weight: ${vitals.weight} kg`} size="small" className="bg-green-50 text-green-800" />
								)}
							</Box>
						</Box>
					)}

					{/* On Exam */}
					{onExam && (
						<Box className="mb-4">
							<Typography variant="subtitle2" className="font-semibold text-blue-800 mb-2">
								On Exam
							</Typography>
							<Typography className="text-sm text-gray-800">
								{onExam}
							</Typography>
						</Box>
					)}

					{/* Diagnosis */}
					{diagnosis && (
						<Box className="mb-4">
							<Typography variant="subtitle2" className="font-semibold text-blue-800 mb-2">
								Diagnosis
							</Typography>
							<Typography className="text-sm text-gray-800">
								{diagnosis}
							</Typography>
						</Box>
					)}
				</Box>

				{/* Right Panel - 4/5th width */}
				<Box className="w-4/5 p-4">

					{/* Medicines */}
					{Object.keys(medicineList).length > 0 && (
						<Box className="mb-6">
							<Typography variant="h6" className="font-semibold text-blue-800 mb-3">
								Medicines
							</Typography>
							<ul className="list-disc ml-6 space-y-2">
								{Object.values(medicineList).map((medicine, index) => (
									<li key={index} className="text-gray-800">
										{medicine}
									</li>
								))}
							</ul>
						</Box>
					)}

					{/* Pathology Tests */}
					{pathologyTests.length > 0 && (
						<Box className="mb-6">
							<Typography variant="h6" className="font-semibold text-blue-800 mb-3">
								Pathology Tests
							</Typography>
							<ul className="list-disc ml-6 space-y-2">
								{pathologyTests.map((test, index) => (
									<li key={index} className="text-gray-800">
										{test[3]} - {test[5]}
									</li>
								))}
							</ul>
						</Box>
					)}

					{/* Radiology Tests */}
					{radiologyTests.length > 0 && (
						<Box className="mb-6">
							<Typography variant="h6" className="font-semibold text-blue-800 mb-3">
								Radiology Tests
							</Typography>
							<ul className="list-disc ml-6 space-y-2">
								{radiologyTests.map((test, index) => (
									<li key={index} className="text-gray-800">
										{test[3]} - {test[6]}
									</li>
								))}
							</ul>
						</Box>
					)}

				{/* Advice */}
				{advices && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Assignment className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								পরামর্শ
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<Typography className="py-1 text-gray-800 ml-8">
							{advices}
						</Typography>
					</Box>
				)}

				{/* Follow-up */}
				{prescription?.followup && (
					<Box className="mb-4">
						<Box className="flex items-center mb-2">
							<Schedule className="text-blue-600 mr-2" />
							<Typography
								variant="h6"
								className="font-semibold text-blue-800"
							>
								Follow-up
							</Typography>
						</Box>
						<Divider className="mb-2" />
						<Typography className="py-1 text-gray-800 ml-8">
							{prescription.followup}
						</Typography>
					</Box>
				)}

				{/* Medicine Usage - Toggle Expandable */}
				{medicineUsageList.length > 0 && (
					<Box className="mb-4">
						<Button
							fullWidth
							variant="contained"
							color="primary"
							onClick={() => setIsExpanded(!isExpanded)}
							className="text-left mb-2"
							sx={{
								justifyContent: "flex-start",
								backgroundColor: "#3b82f6",
								":hover": {
									backgroundColor: "#2563eb",
								},
							}}
						>
							<Box className="flex items-center">
								<Info className="mr-2" />
								<Typography>
									{isExpanded ? "Hide" : "Show"} ঔষুধের
									ব্যবহার বিস্তারিত
								</Typography>
							</Box>
						</Button>

						{isExpanded && (
							<Box className="mt-2 bg-blue-50 p-4 rounded-lg">
								{medicineUsageList.map((usage, index) => (
									<Box
										key={index}
										className={`mb-4 p-4 bg-white rounded-lg shadow-sm border-l-4 border-blue-500 ${
											index !==
											medicineUsageList.length - 1
												? "mb-4"
												: ""
										}`}
									>
										<Typography
											variant="h6"
											className="font-semibold text-blue-800 mb-2"
										>
											{index + 1}. {usage.drugname}
										</Typography>
										<Box className="grid grid-cols-1 gap-x-4 gap-y-2">
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													ব্যবহারের সময়কাল:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.duration || "N/A"}
												</Typography>
											</Box>
											{/* <Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													ঔষধের নাম:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.medicine_name ||
														"N/A"}
												</Typography>
											</Box> */}
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													শারীরবৃত্তীয় প্রভাব:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.physiological_effect ||
														"N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													প্রাথমিক ব্যবহার:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.primary_usage ||
														"N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													সাধারণ ডোজ:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.typical_dose ||
														"N/A"}
												</Typography>
											</Box>
											<Box className="flex items-start">
												<Typography
													variant="body2"
													className="font-medium min-w-32 text-gray-600"
												>
													খাবারের সাথে গ্রহণ:
												</Typography>
												<Typography
													variant="body2"
													className="text-gray-800"
												>
													{usage.medicine_usage
														?.with_meal ||
														"N/A"}
												</Typography>
											</Box>
										</Box>
									</Box>
								))}
							</Box>
						)}
					</Box>
				)}
				</Box>
			</Box>
		</Paper>		
	);
};

export default PhotoPrescriptionPreviewUpdate8Oct25;
